import React, { useCallback, useRef, useState } from "react";
import {
	Button,
	Image,
	message,
	//  Modal,
	Popconfirm,
	Progress,
	Upload,
} from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import plus from "../../assets/svg/plus.svg";
import { btnStyle, ButtonLightPink } from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import delFilled from "../../assets/svg/del_filled.png";
import Webcam from "react-webcam";
import { v4 } from "uuid";
import Auth from "../../lib/middleware/auth";

const UploadWrapper = styled.div`
	.ant-upload.ant-upload-select-picture-card {
		${btnStyle}
		${tw`h-auto! py-4! bg-white! rounded-md! hover:(bg-none! border border-appPink!)`}
		
		${({ noBorder }) =>
			noBorder
				? `border:none !important;`
				: `border: 1px solid #d9d9d9 !important;`}
	}
`;

const ButtonUpload = styled(Button)`
	${tw`h-auto py-3 bg-white rounded flex items-center justify-center gap-2 hover:(bg-white!)`}
	flex-direction: ${({ direction }) => (direction ? direction : "column")};
	width: ${({ width }) => (width ? width : "auto")};
`;

const videoConstraints = {
	width: 220,
	height: 200,
	facingMode: "user",
};

const Thumbnail = styled.div`
	${tw`flex items-center justify-center shadow-md gap-4`}
	min-width: 125px;
	min-height: 125px;
	max-width: 125px;
	max-height: 125px;
	border-radius: 10px;
	background-color: #ddd;
	${({ bg }) => bg && `background: url(${bg});`};
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
`;

// const getBase64 = (file) =>
// 	new Promise((resolve, reject) => {
// 		const reader = new FileReader();
// 		reader.readAsDataURL(file);

// 		reader.onload = () => resolve(reader.result);

// 		reader.onerror = (error) => reject(error);
// 	});

const UploadImage = ({
	setImageUrlList = () => {
		return null;
	},
	imageUrlList,
	maxCount,
	uploadAPI = () => {
		return null;
	},
	uploadText,
	listType,
	multiple,
	credentials,
	useWebCamera,
	cameraHeight,
	cameraWidth,
	captureText,
	buttonContentDirection,
	buttonWidth,
	className,
	noUploadText,
	noBorder,
	disabled,
}) => {
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [showupload, setShowUpload] = useState(true);
	const [rescan, setRescan] = useState(false);
	// const [previewVisible, setPreviewVisible] = useState(false);
	// const [previewImage, setPreviewImage] = useState("");
	// const [previewTitle, setPreviewTitle] = useState("");
	const [selectedUrl, setSelectedUrl] = useState("");
	const token = Auth.getToken();
	const header = {
		Authorization: `Bearer ${token}`,
		"content-type": "multipart/form-data",
	};

	// const handleCancel = () => setPreviewVisible(false);

	// const handlePreview = async (file) => {
	// 	if (!file.url && !file.preview) {
	// 		file.preview = await getBase64(file.originFileObj);
	// 	}

	// 	setPreviewImage(file.url || file.preview);
	// 	setPreviewVisible(true);
	// 	setPreviewTitle(
	// 		file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
	// 	);
	// };

	// using webcam capture
	const [imgSrc, setImgSrc] = useState("");
	const webcamRef = useRef(null);
	const [progress, setProgress] = useState(0);
	const capture = useCallback(() => {
		if (!useWebCamera) {
			return;
		}
		const imageSrc = webcamRef.current.getScreenshot();
		setImgSrc(imageSrc);
		handleUpload({ options: { file: imageSrc } });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [webcamRef]);

	// console.log(useWebCamera);

	function DataURIToBlob(dataURI) {
		const splitDataURI = dataURI.split(",");
		const byteString =
			splitDataURI[0].indexOf("base64") >= 0
				? atob(splitDataURI[1])
				: decodeURI(splitDataURI[1]);
		const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

		const ia = new Uint8Array(byteString.length);
		for (let i = 0; i < byteString.length; i++)
			ia[i] = byteString.charCodeAt(i);

		return new Blob([ia], { type: mimeString });
	}

	const handleFileChange = ({ fileList: newFileList }) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		return setDefaultFileList(newFileList);
	};

	const handleBeforeUpload = (file) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList([...defaultFileList, file]);
		return true;
	};

	const handleUpload = async (options) => {
		const { file, onProgress } = options;
		if (!useWebCamera && isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		if (useWebCamera && isEmpty(imgSrc)) {
			message.warning(
				"No image captured, please proceed to take picture"
			);
		}
		setShowUpload(true);
		const config = {
			headers: { "content-type": "multipart/form-data" },
			onUploadProgress: (event) => {
				const percent = Math.floor((event.loaded / event.total) * 100);
				setProgress(percent);
				if (percent === 100) {
					setTimeout(() => setProgress(0), 1000);
				}
				onProgress({ percent: (event.loaded / event.total) * 100 });
			},
		};
		const formData = new FormData();

		useWebCamera
			? formData.append("media", DataURIToBlob(imgSrc))
			: formData.append("media", file);

		uploadAPI({
			formData,
			config,
			credentials,
		})
			.then((response) => {
				console.log("res upload", response);
				const { hasError } = response;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: response.errors.message,
					});
				}
				const { media_records } = response.data;

				setImageUrlList([]);
				setImageUrlList([media_records[0].media_url]);
				setDefaultFileList([]);
				setShowUpload(false);
			})
			.catch((error) => {
				console.log("Upload Error: ", error);
			});
	};

	const handleMultipleUpload = async () => {
		if (!useWebCamera && isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		setShowUpload(true);
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		const formData = new FormData();
		formData.append("uuid[]", v4());
		defaultFileList.forEach((files) => {
			formData.append(`media`, files);
		});

		uploadAPI({
			formData,
			config,
			credentials,
		})
			.then((response) => {
				console.log("res upload", response);
				const { hasError } = response;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: response.errors.message,
					});
				}
				const { media_records } = response.data;

				imageUrlList.push(media_records[0].media_url);

				setDefaultFileList([]);
				setShowUpload(false);
			})
			.catch((error) => {
				console.log("Upload Error: ", error);
			});
	};

	const handleRemove = (selectedFile) => {
		console.log(selectedFile, "selected");
		const newList = imageUrlList.filter((file) => {
			return selectedFile.uid !== file.uid;
		});
		setImageUrlList(newList);
	};

	// console.log("image url===>\n", imageUrlList);

	return (
		<UploadWrapper noBorder={noBorder}>
			<div tw="mt-2">
				<div tw="flex flex-row gap-3 mt-4 flex-wrap w-full">
					{imageUrlList?.map((url, i) => {
						// console.log(url);
						return (
							<Thumbnail
								bg={url}
								key={i}
								onClick={() => setSelectedUrl(url)}
								tw="mb-2">
								<span
									className="delBg"
									tw="flex items-center justify-center hover:cursor-pointer gap-2">
									{/* <EyeOutlined
										tw="text-gray-200! hover:(shadow-md! text-green-400! text-base)"
										onClick={handlePreview}
									/> */}

									<Popconfirm
										placement="bottom"
										title={`Remove this image?`}
										onConfirm={() => {
											selectedUrl === url &&
												message.success(
													"Image removed"
												);
											return setImageUrlList(
												imageUrlList.filter((file) => {
													return url !== file;
												})
											);
										}}
										okText="Ok"
										cancelText="Back">
										<Image
											preview={false}
											src={delFilled}
											alt=""
											width={14}
											height={15}
											tw="rounded-md"
										/>
									</Popconfirm>
								</span>
							</Thumbnail>
						);
					})}
				</div>
			</div>

			{useWebCamera ? (
				<div tw="flex flex-col items-center justify-center gap-2 w-full">
					<h3>Upload Photo</h3>
					{!rescan ? (
						<>
							<div
								style={{
									height: cameraHeight ? cameraHeight : 200,
									width: cameraWidth ? cameraWidth : 220,
									backgroundColor: "gray",
									borderRadius: "10px",
									overflow: "hidden",
								}}>
								<Webcam
									audio={false}
									height={cameraHeight || 200}
									ref={webcamRef}
									screenshotFormat="image/jpeg"
									width={cameraWidth || 220}
									videoConstraints={videoConstraints}
								/>
							</div>
							<ButtonLightPink
								tw="w-full! h-12"
								disabled={disabled}
								onClick={(e) => {
									e.preventDefault();
									capture();
									setRescan(true);
								}}>
								{captureText ? captureText : "Capture Image"}
							</ButtonLightPink>
						</>
					) : (
						<ButtonLightPink
							tw="w-full! h-12"
							onClick={() => {
								setRescan(false);
							}}>
							Re-snap
						</ButtonLightPink>
					)}
				</div>
			) : multiple ? (
				<Upload
					defaultFileList={defaultFileList}
					accept="image/*"
					onChange={handleFileChange}
					onRemove={handleRemove}
					headers={header}
					action={handleMultipleUpload}
					beforeUpload={handleBeforeUpload}
					listType={listType || "text"}
					// multiple
					showUploadList={showupload}
					maxCount={maxCount || 1}>
					{defaultFileList.length >= (maxCount ? 8 : 1) ? null : (
						<ButtonUpload
							size="large"
							type="text"
							disabled={disabled}
							direction={buttonContentDirection}
							width={buttonWidth}
							className={className}>
							<Image
								preview={false}
								src={plus}
								alt=""
								width={25}
								height={25}
							/>
							{noUploadText ? (
								""
							) : (
								<span tw="opacity-60 text-xs">
									{uploadText
										? uploadText
										: "Upload your image"}
								</span>
							)}
						</ButtonUpload>
					)}
					{progress > 0 ? <Progress percent={progress} /> : null}
				</Upload>
			) : (
				<Upload
					defaultFileList={defaultFileList}
					accept="image/*"
					onChange={handleFileChange}
					onRemove={handleRemove}
					customRequest={handleUpload}
					beforeUpload={handleBeforeUpload}
					listType={listType || "picture-card"}
					showUploadList={showupload}
					maxCount={maxCount || 1}>
					{defaultFileList.length >= 1 ? null : (
						<ButtonUpload
							size="large"
							type="text"
							disabled={disabled}
							direction={buttonContentDirection}
							width={buttonWidth}
							className={className}>
							<Image
								preview={false}
								src={plus}
								alt=""
								width={25}
								height={25}
							/>
							{noUploadText ? (
								""
							) : (
								<span tw="opacity-60 text-xs">
									{uploadText
										? uploadText
										: "Upload your image"}
								</span>
							)}
						</ButtonUpload>
					)}
				</Upload>
			)}

			{/* <Modal
				visible={previewVisible}
				title={previewTitle}
				footer={null}
				onCancel={handleCancel}>
				<img
					alt="example"
					style={{
						width: "100%",
					}}
					src={previewImage}
				/>
			</Modal> */}
		</UploadWrapper>
	);
};

export default UploadImage;
